import { type fabric } from 'fabric';
import type Wireframe from '../objects/Wireframe';
import LinearResizeControl from './LinearResizeControl';

/**
 * Linear Resize Controls.
 *
 * For wireframes, only allow resizing of width. This will directly
 * update the width property
 */
class WireframeLinearResizeControl extends LinearResizeControl {
  constructor(options) {
    super(options);
    this.actionHandler = this.actionHandler.bind(this);
  }

  actionHandler(
    eventData: MouseEvent,
    transformData: fabric.Transform,
    x: number,
    y: number
  ): boolean {
    const didResize = super.actionHandler(eventData, transformData, x, y);
    if (didResize) {
      const object = transformData.target as Wireframe;
      object.setWhetherUserHasSetDimensions();
    }
    return didResize;
  }
}

export default WireframeLinearResizeControl;
